export default {
    '$route': function() {
        const self = this

        self.symplaEvent = {}
        self.resetFormResult()
    }
}
